"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const TextInputPopover_module_scss_1 = __importDefault(require("./TextInputPopover.module.scss"));
const all_1 = require("react-icons/all");
const react_popper_1 = require("react-popper");
const PopoverSharedStyle_module_scss_1 = __importDefault(require("./PopoverSharedStyle.module.scss"));
const TextInputPopover = (props) => {
    const [inputField, setInputField] = (0, react_1.useState)(null);
    const [popover, setPopover] = (0, react_1.useState)(null);
    const [popperElement, setPopperElement] = (0, react_1.useState)(null);
    const { styles, attributes } = (0, react_popper_1.usePopper)(popover, popperElement, {});
    const [popoverActive, setPopoverActive] = (0, react_1.useState)(false);
    const onMediaHandler = () => {
        if (!(inputField === null || inputField === void 0 ? void 0 : inputField.value)) {
            return;
        }
        props.onTextSubmit(inputField === null || inputField === void 0 ? void 0 : inputField.value);
        inputField.value = "";
        setPopoverActive(false);
    };
    const onButtonClickHandler = () => {
        setPopoverActive(true);
        inputField === null || inputField === void 0 ? void 0 : inputField.focus();
    };
    (0, react_1.useEffect)(() => {
        if (inputField) {
            inputField.value = props.prefillText || "";
        }
    }, [inputField, props.prefillText]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        props.children(setPopover, onButtonClickHandler),
        react_1.default.createElement("div", Object.assign({ className: [
                PopoverSharedStyle_module_scss_1.default.popover,
                TextInputPopover_module_scss_1.default.popover,
                popoverActive ? PopoverSharedStyle_module_scss_1.default.active : "",
            ].join(" "), ref: setPopperElement, style: styles.popper }, attributes.popper),
            react_1.default.createElement("input", { placeholder: props.placeholder || "", ref: setInputField, onKeyDown: (event) => {
                    if (event.key === "Enter") {
                        onMediaHandler();
                    }
                } }),
            react_1.default.createElement("button", { type: "button", onClick: onMediaHandler },
                react_1.default.createElement(all_1.AiOutlineEnter, null))),
        react_1.default.createElement("div", { className: `${PopoverSharedStyle_module_scss_1.default.backdrop} ${popoverActive ? PopoverSharedStyle_module_scss_1.default.active : ""}`, onClick: () => {
                setPopover(null);
                setPopoverActive(false);
            } })));
};
exports.default = TextInputPopover;
//# sourceMappingURL=TextInputPopover.js.map